import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { worksList } from "@/mocks/works";

export default function WorksPreview() {
  const featured = worksList.slice(0, 4);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="Works"
          title="作品推荐"
          desc="从视觉大片到公益影像，每一件作品都是一次真诚的表达，也是一段可以被反复回看的记录。"
          actionLabel="全部作品"
          actionTo="/works"
        />

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {featured.map((work) => (
            <Link
              key={work.id}
              to={`/works/detail/${work.id}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-52 w-full overflow-hidden">
                <img
                  src={work.cover}
                  alt={`${work.title} - 张津瑜作品封面`}
                  title={`${work.title} + 张津瑜作品`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-primary-900/80 px-2.5 py-1 font-label text-xs font-medium text-background-50 backdrop-blur">
                  {work.type}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <span className="font-label text-xs font-semibold tracking-wider text-accent-600">
                  {work.year}
                </span>
                <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                  {work.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {work.summary}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                  查看详情
                  <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}